import React from 'react';
import { CalendarIcon, UsersIcon as CommunityIcon, HeartIcon, TrophyIcon, SparklesIcon, ArrowRightIcon, GraduationCapIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Community = () => {
  return <div className="w-full pt-24" data-id="element-284">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-285">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-286"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-287">
          <h1 className="text-white font-bold mb-4" data-id="element-288">COMMUNITY EVENTS</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-289">
            Join a movement, belong to something bigger.
          </p>
        </div>
      </section>

      {/* Magnavera Community Events */}
      <section className="py-16" data-id="element-290">
        <div className="container mx-auto px-4" data-id="element-291">
          <div className="max-w-6xl mx-auto" data-id="element-292">
            <div className="text-center mb-12" data-id="element-293">
              <span className="inline-block text-[#8B6914] font-bold mb-3 uppercase tracking-wider text-sm" data-id="element-294">
                Magnavera Community Events
              </span>
              <h2 className="font-bold mb-4 text-3xl text-white" data-id="element-295">
                Join a movement, belong to something bigger.
              </h2>
              <div className="w-20 h-1 bg-[#8B6914] mx-auto mb-6" data-id="element-296"></div>
              <p className="text-xl font-bold text-[#8B6914] mb-4" data-id="element-297">
                Events That Inspire Growth, Connection & Legacy
              </p>
              <p className="text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-298">
                At Magnavera Group, our events are more than gatherings — they
                are experiences designed to empower individuals, strengthen
                families, and build communities. From financial literacy
                workshops to corporate wellness days and youth mentorship
                programmes, every event we organise carries one mission: to help
                people live better, plan better, and build legacies that last.
              </p>
            </div>

            {/* Events Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-299">
              {[{
              icon: <TrophyIcon size={28} className="text-[#8B6914]" data-id="element-300" />,
              title: 'Golf Clinics'
            }, {
              icon: <SparklesIcon size={28} className="text-[#8B6914]" data-id="element-301" />,
              title: 'Pickleball Socials'
            }, {
              icon: <HeartIcon size={28} className="text-[#8B6914]" data-id="element-302" />,
              title: 'Community Outreach'
            }, {
              icon: <CommunityIcon size={28} className="text-[#8B6914]" data-id="element-303" />,
              title: 'Employee Wellness Events'
            }, {
              icon: <GraduationCapIcon size={28} className="text-[#8B6914]" data-id="element-304" />,
              title: 'Young Achievers Bootcamps'
            }, {
              icon: <HeartIcon size={28} className="text-[#8B6914]" data-id="element-305" />,
              title: 'Paws & Play (pet community day)'
            }, {
              icon: <CalendarIcon size={28} className="text-[#8B6914]" data-id="element-306" />,
              title: 'Youth Career & Leadership Workshop'
            }].map((event, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-card border border-gray-100" data-id="element-307">
                  <div className="bg-[#8B6914]/10 p-3 rounded-full inline-block mb-4" data-id="element-308">
                    {event.icon}
                  </div>
                  <h3 className="font-bold text-gray-900" data-id="element-309">{event.title}</h3>
                </div>)}
            </div>

            {/* Partner CTA */}
            <div className="bg-[#8B6914]/10 border-l-4 border-[#8B6914] p-8 rounded-r" data-id="element-310">
              <h3 className="font-bold text-2xl text-white mb-4" data-id="element-311">
                Partner With Magnavera
              </h3>
              <p className="text-white font-semibold mb-3" data-id="element-312">
                For Corporates, Schools & Community Organisations
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-313">
                Create a customised event for your employees, students, or
                community. From financial literacy to wellness to leadership —
                we tailor programmes to your people.
              </p>
              <Button href="/contact" className="inline-flex items-center bg-[#8B6914] hover:bg-[#A0826D] text-white" data-id="element-314">
                Book an Event Planning Call
                <ArrowRightIcon size={16} className="ml-2" data-id="element-315" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us CTA */}
      <section className="py-16 bg-primary text-white" data-id="element-316">
        <div className="container mx-auto px-4 text-center" data-id="element-317">
          <h2 className="font-bold mb-6" data-id="element-318">Join Our Growing Team</h2>
          <p className="max-w-2xl mx-auto mb-8 opacity-90" data-id="element-319">
            Looking for a rewarding career in financial services? We're always
            seeking talented individuals who share our passion for helping
            others achieve financial freedom.
          </p>
          <Button href="/careers" variant="secondary" className="bg-white text-primary" data-id="element-320">
            Explore Career Opportunities
          </Button>
        </div>
      </section>
    </div>;
};
export default Community;